import React, {
   PropsWithChildren,
   createContext,
   useContext,
   useRef
} from 'react'

import ChatConfigStore from '../stores/ChatConfigStore'

const ChatConfigStoreContext = createContext<ChatConfigStore | null>(null)

export const ChatConfigStoreProvider = (
   props: PropsWithChildren
): React.ReactElement => {
   const chatConfigStoreRef = useRef(ChatConfigStore.create())

   return (
      <ChatConfigStoreContext.Provider value={chatConfigStoreRef.current}>
         {props.children}
      </ChatConfigStoreContext.Provider>
   )
}

export const useChatConfigStore = (): ChatConfigStore => {
   const chatConfigStore = useContext(ChatConfigStoreContext)

   if (!chatConfigStore) {
      throw new Error('Expected to be wrapped in ChatConfigStoreProvider')
   }

   return chatConfigStore
}
